import {HostedInstanceOutageWindowRequest} from "./hostedInstanceOutageWindowRequest";
import {OutageWindowFrequency} from "./outageWindowFrequency";

export type MaintenanceWindow = {
    StartTime: string;
    EndTime: string;
    TimeZone: string;
} & ({
    Frequency: "Daily";
} | {
    Frequency: "Weekly";
    DayOfWeek: string;
} | {
    Frequency: "Monthly";
    WeekOfMonth: "First" | "Second" | "Third";
    DayOfWeek: "Monday";
})

export function mapMaintenanceWindowToHostedInstanceOutageWindowRequest(maintenanceWindow: MaintenanceWindow): HostedInstanceOutageWindowRequest {
    let frequency;

    switch (maintenanceWindow.Frequency) {
        case "Daily":
            frequency = OutageWindowFrequency.Daily;
            break;
        case "Weekly":
            switch (maintenanceWindow.DayOfWeek) {
                case "Monday":
                    frequency = OutageWindowFrequency.MondayOfEachWeek;
                    break;
                case "Tuesday":
                    frequency = OutageWindowFrequency.TuesdayOfEachWeek;
                    break;
                case "Wednesday":
                    frequency = OutageWindowFrequency.WednesdayOfEachWeek;
                    break;
                case "Thursday":
                    frequency = OutageWindowFrequency.ThursdayOfEachWeek;
                    break;
                case "Friday":
                    frequency = OutageWindowFrequency.FridayOfEachWeek;
                    break;
                case "Sunday":
                    frequency = OutageWindowFrequency.SundayOfEachWeek;
                    break;
            }
            break;
        case "Monthly":
            switch (maintenanceWindow.WeekOfMonth) {
                case "First":
                    frequency = OutageWindowFrequency.FirstMondayOfEachMonth;
                    break;
                case "Second":
                    frequency = OutageWindowFrequency.SecondMondayOfEachMonth;
                    break;
                case "Third":
                    frequency = OutageWindowFrequency.ThirdMondayOfEachMonth;
                    break;
            }
            break;
    }

    return {
        OutageWindowFrequency: frequency,
        OutageWindowTimeZone: maintenanceWindow.TimeZone,
        OutageWindowStart: maintenanceWindow.StartTime,
        OutageWindowEnd: maintenanceWindow.EndTime
    }
}
